var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"captiontext"},[_c('div',{style:({
      background: _vm.datas.backColor,
      'border-style': _vm.datas.borderStyle,
      'border-color': _vm.datas.borderColor,
      'border-width': _vm.datas.borderLineWeight + 'px',
      'border-radius': _vm.datas.borderRadius + 'px',
      'padding-top': _vm.datas.paddingTop + 'px',
      'padding-bottom': _vm.datas.paddingBottom + 'px',
      'padding-left': _vm.datas.paddingLeft + 'px',
      'padding-right': _vm.datas.paddingRight + 'px',
      'margin-top': _vm.datas.marginTop + 'px',
      'margin-bottom': _vm.datas.marginBottom + 'px',
      'margin-left': _vm.datas.marginLeft + 'px',
      'margin-right': _vm.datas.marginRight + 'px',
    }),on:{"click":_vm.handleClickName}},[(_vm.datas.name)?_c('div',{class:'class_title_con class_title_' + _vm.datas.styleType,style:({
        'font-size': _vm.datas.wordSize + 'px',
        'font-weight': _vm.datas.isBold ? 'bold' : 'normal',
        'font-style': _vm.datas.isTilt ? 'italic' : 'normal',
        'text-decoration': _vm.datas.isUnderLine ? 'underline' : 'none',
        color: _vm.datas.wordColor,

        '--bgColor': _vm.datas.lineColor,
      })},[_vm._v(" "+_vm._s(_vm.datas.name)+" ")]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }